import useHistoryState from "../hooks/use-history-state.ts";

export default function HistoryState() {
    useHistoryState();

    return null;
}
